import { apiClient } from '@/lib/apiClient';
import type { Perfil, PermissaoFormulario } from '../types';

export const permissoesAdminService = {
  async listarPerfis(): Promise<Perfil[]> {
    const { data } = await apiClient.get('/api/perfis');
    return data;
  },

  async buscarPermissoesDoPerfil(perfilId: number): Promise<PermissaoFormulario[]> {
    const { data } = await apiClient.get(`/api/perfis/${perfilId}/permissoes`);
    return data.formularios ?? [];
  },

  async salvarPermissao(
    perfilId:     number,
    formularioId: number,
    permissao:    Pick<PermissaoFormulario, 'podeLer' | 'podeIncluir' | 'podeEditar' | 'podeExcluir'>
  ): Promise<void> {
    await apiClient.put(`/api/perfis/${perfilId}/permissoes/${formularioId}`, permissao);
  },

  async salvarPorMenu(perfilId: number, menuId: number, concederTudo: boolean): Promise<void> {
    await apiClient.put(`/api/perfis/${perfilId}/permissoes/menu/${menuId}`, { concederTudo });
  },
};
